import React from 'react'

import RecordDetails from '../../../components/RecordDetails'
import ConnectionDetails from './ConnectionDetails'
import StreamSettings from './StreamSettings'

function PostgresForm() {
  return (
    <>
      <ConnectionDetails />
      <RecordDetails name='settings.postgres' />
      <StreamSettings />
    </>
  )
}

export default PostgresForm
